import { Dialog } from "primereact/dialog"
import { useState } from "react"
import _ from 'lodash'
import Loading from "../../../common/Loading"
import { Button, DropDownField, TextInputField } from "../../../helpers"
import { releaseClientHoldInitialValues, releaseClientHoldValidationSchema } from "../../../validation/stockAdjustment"
import { getClientHoldCreditNotesByWarehouseId, releaseClientHoldCreditNote } from "../../../services/api/stockAdjustment"
import { getMaterialMasterAndTempMaterialIds } from "../../../services/api/materialMaster"
import { useDispatch } from "react-redux"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { sortArrayOfObjectsInAlphabeticalOrder, validateInputs } from "../../../utils"


const ReleaseClientHold = (props) => {

    const {companyWarehouses, setVisibleReleaseClientHold, materialBrands} = props

    const [releaseClientHold, setReleaseClientHold] = useState(releaseClientHoldInitialValues)
    const [buyerCreditNotes, setBuyerCreditNotes] = useState([])
    const [creditNoteStockMoves, setCreditNoteStockMoves] = useState([])
    const [clientHoldProducts, setClientHoldProducts] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    const [creditNoteStockMovesDataLoading, setCreditNoteStockMovesDataLoading] = useState(false)

    const [formErrors, setFormErrors] = useState([])

    const dispatch = useDispatch()

    const handleWarehouseChange = async (e) => {
        setCreditNoteStockMovesDataLoading(true)

        const stockWarehouseRes = await getClientHoldCreditNotesByWarehouseId(e.target.value)

        if(stockWarehouseRes.failure){
            setCreditNoteStockMovesDataLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'Stock Warehouses', detail: stockWarehouseRes.data.error, life: 3000}))
        }
        setCreditNoteStockMoves(stockWarehouseRes.data)

        let uniqueCreditNoteStockMoves = _.uniqBy(stockWarehouseRes.data, "docNo")
        uniqueCreditNoteStockMoves = sortArrayOfObjectsInAlphabeticalOrder(uniqueCreditNoteStockMoves, 'docNo')
        setBuyerCreditNotes(uniqueCreditNoteStockMoves)

        if (stockWarehouseRes.data.length > 0) {
            const materialIds = _.uniqBy(stockWarehouseRes.data.map(eachStockWar => eachStockWar.materialId))
            const materialRes = await getMaterialMasterAndTempMaterialIds({ materialIds })

            if (materialRes.failure) {
                setCreditNoteStockMovesDataLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Materials', detail: materialRes.data.error, life: 3000 }))
            }

            const sortedMaterialDetails = _.sortBy(materialRes.data, 'materialId')
            setMaterialDetails(sortedMaterialDetails)
            setClientHoldProducts([])
        }
        else if(stockWarehouseRes.data.length === 0){
            setClientHoldProducts([])
            setMaterialDetails([])
            dispatch(raiseToast({ severity: 'error', detail: "No client hold materials were found!", life: 3000 }))
        }

        const updatedReleaseClientHold = { ...releaseClientHoldInitialValues, warehouseId: e.target.value }

        setReleaseClientHold({ ...updatedReleaseClientHold})
        setCreditNoteStockMovesDataLoading(false)
    }

    const handleOnHideProcesssClientHold = () => {
        setReleaseClientHold(releaseClientHoldInitialValues)
        setBuyerCreditNotes([])
        setCreditNoteStockMoves([])
        setClientHoldProducts([])
        setMaterialDetails([])
        setVisibleReleaseClientHold(false)
    }

    const handleClientHoldChange = (e) => {
        if(e.target.name === "crediNoteDocNo"){
            let relatedCreditNoteMaterials = creditNoteStockMoves.filter(eachStockMove => eachStockMove.docNo === e.target.value)
            setClientHoldProducts(relatedCreditNoteMaterials)
        }

        releaseClientHold[e.target.name] = e.target.value 
        setReleaseClientHold({...releaseClientHold})
    }

    const handleClientHoldSubmit = async () => {
        const validationRes = await validateInputs(releaseClientHoldValidationSchema, releaseClientHold)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {
                setFormErrors({})

                if(window.confirm("Are you sure you want to continue?")){
                    setIsLoading(true)

                    const releaseClientHoldRes = await releaseClientHoldCreditNote({releaseClientHold, clientHoldProducts})

                    if(releaseClientHoldRes.failure){
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: 'Release Client Hold', detail: releaseClientHoldRes.data.error, life: 3000 }))
                    }

                    setIsLoading(false)
                    handleOnHideProcesssClientHold()
                }
            }
        }
    }

    return (
        <Dialog header="Release Client Hold Credit Notes" visible={props.visible} style={{ minHeight: "60%", width: '60vw' }} onHide={handleOnHideProcesssClientHold}>
            <Loading visible={isLoading} />
            <div className="flex flex-wrap">
                <div className="flex flex-row col-12 p-0">
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <DropDownField name="warehouseId" options={companyWarehouses} optionValue="warehouseId" optionLabel="warehouseName" labelText="Warehouse" value={releaseClientHold.warehouseId} onChange={handleWarehouseChange} disabled={creditNoteStockMovesDataLoading} required errorMessage={formErrors.warehouseId} />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <DropDownField name="crediNoteDocNo" labelText="Credit Note" options={buyerCreditNotes} value={releaseClientHold.crediNoteDocNo} optionLabel="docNo" optionValue="docNo" onChange={handleClientHoldChange} disabled={creditNoteStockMovesDataLoading} errorMessage={formErrors.crediNoteDocNo} loading={creditNoteStockMovesDataLoading} required />
                    </div>
                </div>
                {
                    clientHoldProducts.map(eachProduct => {
                        const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === eachProduct.materialId)
                        const relateedBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterial.brandId)
                        const productName = `${relateedBrand.brandName}-${relatedMaterial.productName}${relatedMaterial.variantName ? `-${relatedMaterial.variantName}`: ''}`

                        return (
                            <div className="flex flex-row col-12 p-0" key={`clientHoldProduct-${eachProduct.materialId}`}>
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <TextInputField name="Material" value={eachProduct.materialId} labelText="Material" disabled required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                                    <TextInputField name="Material" value={productName} labelText="Product" disabled tooltip={productName} tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }} required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                                    <TextInputField name="Material" value={relatedMaterial.productSpecification} labelText="Specification" disabled tooltip={relatedMaterial.productSpecification} tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }} required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <TextInputField name="Material" value={eachProduct.price} labelText="Price" disabled required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <TextInputField name="Material" value={eachProduct.moveQty} labelText="Qty" disabled required />
                                </div>
                            </div>
                        )
                    })
                }
                {/* <div className="flex flex-column col-12 text-area">
                    <TextAreaField name="remarks" labelText="Remarks" rows={3} value={releaseClientHold.remarks} onChange={handleClientHoldChange} required errorMessage={formErrors.remarks} maxLength={100} />
                </div> */}

            </div>
            {
                releaseClientHold.warehouseId && releaseClientHold.crediNoteDocNo && clientHoldProducts.length &&
                <div className='flex justify-content-center align-items-center mt-2'>
                    <Button label="Submit" onClick={handleClientHoldSubmit} />
                </div>
            }
        </Dialog>
    )
}

export default ReleaseClientHold